export { AutoCleanedStrongCache, AutoCleanedWeakCache } from "./caches.js";
export { cacheSizes } from "./sizes.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/caching/index.js
// module id = 569
// module chunks = 11